<template>
  <!-- <book>
  </book> -->
  <!-- <div class="description">
    <h2>iBEGOO is a multi-purpose and multi-user software which serves as a new platform for storytellers, directors, and producers to facilitate the process of writing interative narratives for immersive expereiences. iBEGOO steamlines the creation of AI-enabled Augmented Reality mobile applications from ideation, writing, productuion, to consumption. </h2>
    <br>
    <h2>This project is developed by Amir Baradaran and his research team at Columbia University Computer and Graphics User Interface Lab.</h2>
  </div> -->
  <v-layout justify-center align-center row>
    <!-- <h3>Watch our promotional video for iBEGOO: </h3> -->
    <v-flex class="text-xs-center" xs12 >
      <vimeo-player ref="player" :video-id="videoID" @ready="onReady" @click="play" :player-height="height"></vimeo-player>
    </v-flex>
  </v-layout>
  <!--<v-flex class="description" xs12>
    <h3>iBEGOO is a multi-purpose, multi-user software which serves as a new platform for storytellers, directors, and producers to facilitate the writing of interative narratives for immersive expereiences. We steamline the creation of AI-enabled Augmented Reality mobile applications from ideation, to writing, productuion, and consumption.</h3>
    <br>
    <h3>This project is developed by Amir Baradaran and his research team at the Columbia University Computer and Graphics User Interface Lab.</h3>
    <br>
  </flex>-->
</template>

<script>
// import book from '../components/book/book.vue'

export default {
  name: 'Home',
  data () {
    return {
      videoID: '298314573',
      height: 600,
      options: {},
      playerReady: false
    }
  },
  created () {
  },
  components: {
    // book,
  },
  methods: {
    onReady () {
      this.playerReady = true
    },
    play () {
      this.$refs.player.play()
    },
    stop () {
      this.$refs.player.stop()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Home.vue